import { LOAD_DEMANDS, SELECT_DEMAND, CLEAN_SELECTED_DEMAND } from "../actions/actionTypes";

const initialState = {
    demands: [],
    selectedDemand: null
};

export const demandsReducer = (state = initialState, action) => {
    switch (action.type) {
        case LOAD_DEMANDS:
            return {
                ...state,
                demands: action.demands
            };
        case SELECT_DEMAND:
            return {
                ...state,
                selectedDemand: action.demand
            };
        case CLEAN_SELECTED_DEMAND:
            return {
                ...state,
                selectedDemand: null
            };
        default:
            return state;
    }
};